export default __webpack_public_path__ + "static/media/ceremony.a3ca342c.PNG";